/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Response to update the postal address of a person
 * @export
 * @interface UpdateAddressPersonResponse
 */
export interface UpdateAddressPersonResponse {
    /**
     * the name of the street in the address
     * @type {string}
     * @memberof UpdateAddressPersonResponse
     */
    street?: string;
    /**
     * the locality in the address
     * @type {string}
     * @memberof UpdateAddressPersonResponse
     */
    locality?: string;
    /**
     * the postal code in the address
     * @type {string}
     * @memberof UpdateAddressPersonResponse
     */
    postalCode?: string;
    /**
     * the code iso of the country
     * @type {string}
     * @memberof UpdateAddressPersonResponse
     */
    country?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateAddressPersonResponse
     */
    note?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateAddressPersonResponse
     */
    isFavorite?: boolean;
}

/**
 * Check if a given object implements the UpdateAddressPersonResponse interface.
 */
export function instanceOfUpdateAddressPersonResponse(value: object): value is UpdateAddressPersonResponse {
    return true;
}

export function UpdateAddressPersonResponseFromJSON(json: any): UpdateAddressPersonResponse {
    return UpdateAddressPersonResponseFromJSONTyped(json, false);
}

export function UpdateAddressPersonResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateAddressPersonResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'street': json['street'] == null ? undefined : json['street'],
        'locality': json['locality'] == null ? undefined : json['locality'],
        'postalCode': json['postalCode'] == null ? undefined : json['postalCode'],
        'country': json['country'] == null ? undefined : json['country'],
        'note': json['note'] == null ? undefined : json['note'],
        'isFavorite': json['isFavorite'] == null ? undefined : json['isFavorite'],
    };
}

export function UpdateAddressPersonResponseToJSON(json: any): UpdateAddressPersonResponse {
    return UpdateAddressPersonResponseToJSONTyped(json, false);
}

export function UpdateAddressPersonResponseToJSONTyped(value?: UpdateAddressPersonResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'street': value['street'],
        'locality': value['locality'],
        'postalCode': value['postalCode'],
        'country': value['country'],
        'note': value['note'],
        'isFavorite': value['isFavorite'],
    };
}

